import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-open-line text-base text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                  韩国漫画网
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                韩国漫画网是专业的韩漫在线阅读平台，每日更新海量热门韩漫作品，涵盖全品类题材，为漫画爱好者提供优质的阅读体验。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
                </li>
                <li>
                  <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
                </li>
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-mail-line mt-0.5"></i>
                  <span>contact@koreancomic.cn</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-400">
                  <i className="ri-map-pin-line mt-0.5"></i>
                  <span>北京市朝阳区漫画大厦</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-12 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-sm text-background-500">
                &copy; {new Date().getFullYear()} 韩国漫画网. 保留所有权利.
              </p>
              <p className="text-sm text-background-500">
                本站所有漫画均来自网络，仅供学习交流使用
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}